var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "app-main-content" }, [
    _c(
      "div",
      { staticClass: "tabs-container" },
      [
        _c(
          "el-tabs",
          {
            ref: "tabs",
            staticStyle: { width: "100%" },
            attrs: { type: "card" },
            on: { "tab-click": _vm.handleClick },
            model: {
              value: _vm.activeTabName,
              callback: function($$v) {
                _vm.activeTabName = $$v
              },
              expression: "activeTabName"
            }
          },
          [
            _vm.$route.params.redisKey
              ? _c(
                  "el-tab-pane",
                  {
                    attrs: {
                      label: _vm.$t("CargoMsg.AutomaticReconciliation"),
                      name: "automaticReconciliation",
                      lazy: true
                    }
                  },
                  [_c("tab-automatic-reconciliation")],
                  1
                )
              : _vm._e(),
            _c(
              "el-tab-pane",
              {
                attrs: {
                  label: _vm.$t("CargoMsg.AutomaticReconciliationHistory"),
                  name: "automaticReconciliationHistory",
                  lazy: true
                }
              },
              [
                _c("tab-automatic-reconciliation-history", {
                  ref: "automaticReconciliationHistory"
                })
              ],
              1
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }